export const Check = Object.freeze({
	status: {
		new: 'N',
		error: 'E',
		process: 'P',
		printed: 'Y'
	}
});